import { WorklistsReportDataRow } from '@/app/components/Reporting/Collaboration/WorklistsReport/types';
import { useCallback, useMemo } from 'react';
import { getEnums } from '@/old/utils/helper';
import { ICollaborationTemplate } from '@/app/components/Worklist/types';

export const useFormattedWorklistData = (
  dataRows: WorklistsReportDataRow[],
  templates: ICollaborationTemplate[],
) => {
  // get Enum names for workflow status
  const worklistStatusEnums = useMemo(() => {
    return getEnums('COLLAB_TASK_STATUS').filter((item: any) =>
      item.hasOwnProperty('isActive') ? item.isActive : true,
    );
  }, []);
  const getStatusTranslation = useCallback(
    (type: string) => {
      const wlStatus = worklistStatusEnums.find((item: any) => item.code === type);
      if (!wlStatus) {
        return '';
      }
      return wlStatus.name;
    },
    [worklistStatusEnums],
  );

  const getTemplate = useCallback((templateId: number) => {
      return templates.find((t) => t.id === templateId);
  }, [templates]);

  return dataRows.map(row => {
    const { worklistStatus, worklistId } = row;

    const template = getTemplate(worklistId);

    return {
      ...row,
      worklistName: template ? template.title : '',
      worklistStatus: getStatusTranslation(worklistStatus),
    };
  });
};
